import { Input } from "./Input"
import { IAddr } from "../../interfaces/IAddr"

/*
contact - dane kontaktowe
contact_offer - rozszerzone dane kontaktowe używane w przypadku ofert
inv_priv - osoba fizyczna -> dane na fakturzr
inv_payer - firma, płatnik
inv_recipent - firma odniorca
*/

export type AddrInputType = 'contact_offer' |'contact' |'inv_priv' | 'inv_payer' | 'inv_recipent';


export interface IAddrFormInputs {
  prefixName: string,    // dodawany do nazwy pól
  register?: any,
  data?:IAddr,
  addrType: AddrInputType,  // na podstawie tego ustalamy co ma być w formularzu  
  setData(data: IAddr):any  // callback
  errors: any               // callback
  forceRequired?: boolean // czy pola są obowiązkowe (w przypadku definiowania formularza w ustawieniach użytkownika nie ma potrzeby definiowania wszystkich pól)
}

export const AddrFormInputs = (props: IAddrFormInputs) => {
    
    if (props.data === undefined)
      return (
        <></>
        )

    let addrData=props.data
    let forceRequired=props.forceRequired===undefined?true:props.forceRequired

//    console.log(props.userInfo)
    // if (props.userInfo !== undefined)
    //   addrData.aName=props.userInfo.first_name

    function handleChange (e: React.ChangeEvent<HTMLInputElement>) {
                
        if ((props.prefixName + "aName") === e.target.id) {
          addrData.aName=e.target.value
        } 
        else if ((props.prefixName + "email") === e.target.id) {
          addrData.email=e.target.value
        } 
        else if ((props.prefixName + "NIP") === e.target.id) {
          addrData.NIP=e.target.value
        } 
        else if ((props.prefixName + "line1") === e.target.id) {
          addrData.line1=e.target.value
        } 
        else if ((props.prefixName + "postcode") === e.target.id) {
          addrData.postcode=e.target.value
        } 
        else if ((props.prefixName + "city") === e.target.id) {
          addrData.city=e.target.value
        } 
        else if ((props.prefixName + "company") === e.target.id) {
          addrData.company=e.target.value
        } 
        else if ((props.prefixName + "tel") === e.target.id) {
          addrData.tel=e.target.value
        } 
        props.setData(addrData)
    }



    return (
        <>
        {props.data &&
          <>
            
            { ((props.addrType === 'contact') || (props.addrType === 'contact_offer') || (props.addrType === 'inv_priv'))  && (
                      <>
                      <Input
                        id={props.prefixName + "aName"}
                        name="aName"
                        label="imię i nazwisko"
                        placeholder="imię i nazwisko"
                        register={props.register}
                        onChange={handleChange}
                        defaultValue={props.data.aName}
                        errors={props.errors}
                        required={forceRequired}
                      ></Input>
                      </>
            )}

            { props.addrType === 'contact_offer' && (
                        <>
                        <Input
                          id={props.prefixName + "company"}
                          name="nazwa instytucji"
                          label="nazwa instytucji"
                          placeholder="nazwa instytucji"
                          register={props.register}
                          onChange={handleChange}
                          defaultValue={props.data.company}
                          errors={props.errors}
                          required={forceRequired}
                        ></Input>
                        <Input
                          id={props.prefixName + "city"}
                          name="miasto"
                          label="miasto"
                          placeholder="miasto"
                          register={props.register}
                          onChange={handleChange}
                          defaultValue={props.data.city}
                          errors={props.errors}
                          required={forceRequired}
                        ></Input>
                        </>
            )}

            { ((props.addrType === 'contact') || (props.addrType === 'contact_offer')) && (
                      <>
                      <Input
                        id={props.prefixName + "email"}
                        name="email"
                        label="email"
                        placeholder="email"
                        register={props.register}
                        onChange={handleChange}
                        defaultValue={props.data.email}
                        errors={props.errors}
                        validateType="email"
                      ></Input>

                      <Input
                        id={props.prefixName + "tel"}
                        name="numer telefonu"
                        label="numer telefonu"
                        placeholder="numer telefonu"
                        register={props.register}
                        onChange={handleChange}
                        defaultValue={props.data.tel}
                        errors={props.errors}    
                        required={false}          
                      ></Input>
                      </>
            )}

            {props.addrType === 'inv_payer' && (
              <>
              <Input
                id={props.prefixName + "company"}
                name="nazwa płatnika (np. nazwa organu prowadzącego)"
                label="nazwa płatnika"
                placeholder="nazwa płatnika"
                register={props.register}
                onChange={handleChange}
                defaultValue={props.data.company}
                errors={props.errors}
                required={forceRequired}
              ></Input>
              </>
            )}

            {props.addrType === 'inv_recipent' && (
              <>
              <Input
                id={props.prefixName + "company"}
                name="nazwa odbiorcy (np. nazwa szkoły)"
                label="nazwa odbiorcy"
                placeholder="nazwa odbiorcy"
                register={props.register}
                onChange={handleChange}
                defaultValue={props.data.company}
                errors={props.errors}
                required={forceRequired}
              ></Input>
              </>
            )}

            {((props.addrType === 'inv_priv') ||(props.addrType === 'inv_payer') ||(props.addrType === 'inv_recipent') ) && (
              <>
                <Input
                  id={props.prefixName + "line1"}
                  name="adres"
                  label="adres"
                  placeholder="adres"
                  register={props.register}
                  onChange={handleChange}
                  defaultValue={props.data.line1}
                  errors={props.errors}
                  required={forceRequired}
                ></Input>

                <Input
                  id={props.prefixName + "postcode"}
                  name="kod pocztowy"
                  label="kod pocztowy"
                  placeholder="kod pocztowy"
                  register={props.register}
                  onChange={handleChange}
                  defaultValue={props.data.postcode}
                  errors={props.errors}
                  required={forceRequired}
                  ></Input>

                <Input
                  id={props.prefixName + "city"}
                  name="miasto"
                  label="miasto"
                  placeholder="miasto"
                  register={props.register}
                  onChange={handleChange}
                  defaultValue={props.data.city}
                  errors={props.errors}
                  required={forceRequired}
                ></Input>
              </>
            )}  

            {props.addrType === 'inv_payer' && (
              <>
              <Input
                id={props.prefixName + "NIP"}
                name="NIP"
                label="NIP"
                placeholder="NIP"
                register={props.register}
                onChange={handleChange}
                defaultValue={props.data.NIP}
                errors={props.errors}
                required={forceRequired}
              ></Input>
              </>
            )}
              

          </>        
      }
      </>
    )
  }